
// import "./Permission.css";
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import Button from "@mui/material/Button";
// import StepIndicator from "./StepIndicator";
// import Support from "../../contact-popup-module/Support";
// import InternetSignal from "../internet-strength/InternetSignal";
// import CloseIcon from "@mui/icons-material/Close";
// import { IconButton } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import tick_icon from "../location-camera-permission/tick_icon.png";
// import { set_latitude_longitude, setAuditID } from "../../store/images";

// const Permission2 = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { audit_id } = useParams();

//   const [cameraPermission, setCameraPermission] = useState(false);
//   const [locationPermission, setLocationPermission] = useState(false);
//   const [audioPermission, setAudioPermission] = useState(false);

//   const [openPermissionDialog, setOpenPermissionDialog] = useState(false);
//   const [openLocPermissionDialog, setOpenLocPermissionDialog] = useState(false);
//   const [openCamPermissionDialog, setOpenCamPermissionDialog] = useState(false);
//   const [openAudioPermissionDialog, setOpenAudioPermissionDialog] = useState(false);

//   const [locationError, setLocationError] = useState(null);

//   const [dialogWidth, setDialogWidth] = useState("29vw");
//   const [dialogText, setDialogText] = useState("0.9rem");

//   const [locationPermStatus, setLocationPermStatus] = useState("denied");
//   const [cameraPermStatus, setCameraPermStatus] = useState("denied");
//   const [audioPermStatus, setAudioPermStatus] = useState("denied");

//   const [configDataStatus, setConfigDataStatus] = useState(false);
//   const [proceedStatus, setProceedStatus] = useState(false);

//   const [retryCount, setRetryCount] = useState(0);

//   const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
//   const [speed, setSpeed] = useState(null);

//   const [isWebView, setIsWebView] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");

//   const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
//   const location_icon = `${process.env.PUBLIC_URL}/custom-icons/location.png`;
//   const camera_icon = `${process.env.PUBLIC_URL}/custom-icons/camera.png`;
//   const audio_icon = `${process.env.PUBLIC_URL}/custom-icons/audio.png`;
//   const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;

//   const uid = useSelector((state) => state.imagesStore.user_userID);
//   console.log("permission uid", uid);

//   // Detect WebView
//   useEffect(() => {
//     const checkWebView = () => {
//       const userAgent = window.navigator.userAgent.toLowerCase();
//       return (
//         userAgent.includes("wv") ||
//         userAgent.includes("fb") ||
//         window.webkit?.messageHandlers
//       );
//     };
//     setIsWebView(checkWebView());
//   }, []);

//   // Responsive dialog size
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 400) setDialogWidth("85vw");
//       else if (window.innerWidth <= 475) setDialogWidth("74vw");
//       else if (window.innerWidth <= 575) {
//         setDialogText("0.6rem");
//         setDialogWidth("64vw");
//       } else if (window.innerWidth <= 650) setDialogWidth("60vw");
//       else if (window.innerWidth <= 775) setDialogWidth("57vw");
//       else if (window.innerWidth <= 875) setDialogWidth("55vw");
//       else if (window.innerWidth <= 1000) setDialogWidth("48vw");
//       else if (window.innerWidth <= 1100) {
//         setDialogWidth("45vw");
//         setDialogText("0.8rem");
//       } else if (window.innerWidth <= 1300) setDialogWidth("40vw");
//       else setDialogWidth("35vw");
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Fetch audit details
//   const [auditData, setAuditData] = useState(null);
//   useEffect(() => {
//     const fetchDetails = async () => {
//       try {
//         const response = await axios.get(
//           `/create_audit/get_audit_details2/${audit_id}`
//         );
//         setConfigDataStatus(true);
//         setAuditData(response.data);
//         localStorage.setItem(
//           "inspectionConfiguration",
//           JSON.stringify(response.data)
//         );
//       } catch (error) {
//         console.error("Error fetching audit details:", error);
//       }
//     };

//     if (audit_id) fetchDetails();
//   }, [audit_id]);

//   // Permission request helpers (single source of truth)
//   const requestCameraPermission = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: { facingMode: "environment" }
//       });
//       stream.getTracks().forEach((t) => t.stop());
//       setCameraPermission(true);
//       setCameraPermStatus("granted");
//       return true;
//     } catch (error) {
//       console.error("Camera permission error:", error);
//       setCameraPermission(false);
//       setCameraPermStatus("denied");

//       if (error.name === "NotAllowedError") {
//         alert("Please enable camera access in your device settings");
//       } else if (error.name === "NotFoundError") {
//         alert("No camera found on device");
//       } else {
//         alert("Camera access failed. Please check device settings.");
//       }
//       return false;
//     }
//   };

//   const requestAudioPermission = async () => {
//     try {
//       if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//         throw new Error("Media devices API not available");
//       }

//       const stream = await navigator.mediaDevices.getUserMedia({
//         audio: true,
//         video: false
//       });

//       stream.getTracks().forEach((t) => t.stop());

//       setAudioPermission(true);
//       setAudioPermStatus("granted");
//       setErrorMessage("");
//       return true;
//     } catch (error) {
//       console.error("Microphone access error:", error);
//       setAudioPermission(false);

//       let message = "";
//       if (
//         error.name === "NotAllowedError" ||
//         error.name === "PermissionDeniedError"
//       ) {
//         message = "Microphone permission was denied. Please enable it in your settings.";
//         setAudioPermStatus("denied");
//       } else if (error.name === "NotFoundError") {
//         message = "No microphone device found.";
//       } else if (error.name === "NotReadableError") {
//         message = "Microphone is already in use or not functioning properly.";
//       } else if (error.name === "SecurityError") {
//         message = isWebView
//           ? "WebView permissions not properly configured. Please check app settings."
//           : "Security error accessing microphone.";
//       } else {
//         message = `Error accessing microphone: ${error.message}`;
//       }
//       setErrorMessage(message);
//       return false;
//     }
//   };

//   const requestLocationPermission = async () => {
//     console.log("Requesting location permission...");

//     if (!navigator.geolocation) {
//       setLocationError("Geolocation not supported");
//       setLocationPermStatus("denied");
//       setLocationPermission(false);
//       return false;
//     }

//     const options = {
//       enableHighAccuracy: true,
//       timeout: 30000,
//       maximumAge: 0
//     };

//     setRetryCount((c) => c + 1);

//     return new Promise((resolve) => {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLocationPermission(true);
//           setLocationPermStatus("granted");
//           setLocationError(null);
//           resolve(true);
//         },
//         (error) => {
//           console.error("Location error:", error);
//           setLocationPermission(false);
//           setLocationPermStatus("denied");

//           let msg = "";
//           switch (error.code) {
//             case error.PERMISSION_DENIED:
//               msg = "Location permission denied";
//               break;
//             case error.POSITION_UNAVAILABLE:
//               msg = "Location information unavailable";
//               break;
//             case error.TIMEOUT:
//               msg = "Location request timed out";
//               break;
//             default:
//               msg = "Unknown location error";
//           }
//           setLocationError(msg);
//           resolve(false);
//         },
//         options
//       );
//     });
//   };

//   // Bounded auto-check on mount (NO infinite loops)
//   // useEffect(() => {
//   //   const run = async () => {
//   //     // Attempt once each (or twice max if you want)
//   //     await requestCameraPermission();
//   //     await requestAudioPermission();
//   //     await requestLocationPermission();
//   //   };
//   //   run();
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, []);

//   // proceedStatus (make consistent: require all 3 + config)
//   useEffect(() => {
//     const canProceed =
//       cameraPermStatus === "granted" &&
//       audioPermStatus === "granted" &&
//       locationPermStatus === "granted" &&
//       configDataStatus;

//     setProceedStatus(canProceed);
//   }, [cameraPermStatus, audioPermStatus, locationPermStatus, configDataStatus]);

//   // Speed test (reduced frequency & size)
//   const testSpeed = async () => {
//     const fileSize = 1 * 1024 * 1024; // 1MB
//     const testFile = "https://speed.cloudflare.com/__down?bytes=1000000";
//     const startTime = Date.now();

//     try {
//       const response = await fetch(testFile);
//       await response.arrayBuffer();
//       const endTime = Date.now();
//       const durationInSeconds = (endTime - startTime) / 1000;
//       const speedMbps = (
//         (fileSize / durationInSeconds / (1024 * 1024)) *
//         8
//       ).toFixed(2);
//       setSpeed(Number(speedMbps));
//     } catch (error) {
//       console.error("Speed test failed:", error);
//       setSpeed(null);
//     }
//   };

//   useEffect(() => {
//     testSpeed();
//     const intervalId = setInterval(testSpeed, 15000);
//     return () => clearInterval(intervalId);
//   }, []);

//   const handleDialogClose = () => setOpenDialogLowInternet(false);

//   const handleRetry = (type) => {
//     if (type === "location") {
//       setOpenLocPermissionDialog(true);
//       requestLocationPermission(); // ✅ fixed
//     } else if (type === "camera") {
//       setOpenCamPermissionDialog(true);
//       requestCameraPermission();
//     } else if (type === "audio") {
//       setOpenAudioPermissionDialog(true);
//       requestAudioPermission();
//     }
//   };

//   const handleButtonClick = async () => {
//     if (!proceedStatus) {
//       if (locationPermStatus !== "granted") await requestLocationPermission();
//       if (cameraPermStatus !== "granted") await requestCameraPermission();
//       if (audioPermStatus !== "granted") await requestAudioPermission();
//       return;
//     }

//     // Proceed - capture coords (best effort) then navigate
//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         dispatch(set_latitude_longitude({ latitude, longitude }));
//         dispatch(setAuditID(audit_id));
//         navigate(`/landscapeMode/${audit_id}`);
//       },
//       () => {
//         dispatch(setAuditID(audit_id));
//         navigate(`/landscapeMode/${audit_id}`);
//       }
//     );
//   };

//   // Support popup
//   const [openSupport, setOpenSupport] = useState(false);
//   const handleClickOpen = () => setOpenSupport(true);
//   const handleClose = () => setOpenSupport(false);

//   return (
//     <div className="loc-cam-permission-parent">
//       {speed !== null && <InternetSignal signalStrength={speed} />}

//       <img
//         src={query_icon}
//         alt="Query Icon"
//         className="question-div"
//         onClick={handleClickOpen}
//       />

//       <Dialog
//         open={openSupport}
//         onClose={handleClose}
//         className="support-popup-dialog"
//       >
//         <DialogContent className="support-popup-content">
//           <Support />
//           <button onClick={handleClose} className="close-btn">
//             close
//           </button>
//         </DialogContent>
//       </Dialog>

//       <div className="permissions-page">
//         <StepIndicator stepNumber={2} />
//         <p className="allow-permission-step-indicator">
//           All permissions {locationPermStatus}
//         </p>
//         <p className="allow-permission-div">Allow permission on your device</p>

//         <div className="permission-card-parent">
//           {/* CAMERA */}
//           <div className="permission-card">
//             <div style={{ display: "flex", alignItems: "flex-end", gap: "0.3rem" }}>
//               <img src={camera_icon} style={{ width: "20px", height: "19px" }} alt="" />
//               <p style={{ fontFamily: "Barlow Condensed", fontSize: "18px", fontWeight: "600", color: "#000000DE" }}>
//                 Camera
//               </p>
//             </div>

//             <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", fontWeight: "400" }}>
//               For capturing the livestock
//             </p>

//             {cameraPermStatus === "granted" ? (
//               <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", color: "#FC350B", display: "flex", alignItems: "center", gap: "0.3rem", position: "absolute", bottom: "20px", right: "10px" }}>
//                 <img src={tick_icon} style={{ width: "14px" }} alt="" />
//                 <span>Allowed</span>
//               </div>
//             ) : (
//               <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
//                 <button
//                   style={{ border: "1.5px solid #FC350B", padding: "0.1rem 0.5rem", backgroundColor: "white", borderRadius: "4px" }}
//                   onClick={() => handleRetry("camera")}
//                 >
//                   <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.3rem", margin: 0 }}>
//                     {cameraPermStatus === "prompt" ? "Allow" : "Retry"}
//                   </p>
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* LOCATION */}
//           <div className="permission-card">
//             <div style={{ display: "flex", alignItems: "flex-end", gap: "0.3rem" }}>
//               <img src={location_icon} style={{ width: "20px", height: "20px" }} alt="" />
//               <p style={{ fontFamily: "Barlow Condensed", fontSize: "18px", fontWeight: "600", color: "#000000DE" }}>
//                 Location
//               </p>
//             </div>

//             <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", fontWeight: "400" }}>
//               For the location of the inspection
//             </p>

//             {locationPermStatus === "granted" ? (
//               <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", color: "#FC350B", display: "flex", alignItems: "center", gap: "0.3rem", position: "absolute", bottom: "20px", right: "10px" }}>
//                 <img src={tick_icon} style={{ width: "14px" }} alt="" />
//                 <span>Allowed</span>
//               </div>
//             ) : (
//               <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
//                 <button
//                   style={{ border: "1.5px solid #FC350B", padding: "0.1rem 0.5rem", backgroundColor: "white", borderRadius: "4px" }}
//                   onClick={() => handleRetry("location")}
//                 >
//                   <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.3rem", margin: 0 }}>
//                     {locationPermStatus === "prompt" ? "Allow" : "Retry"}
//                   </p>
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* AUDIO */}
//           <div className="permission-card">
//             <div style={{ display: "flex", alignItems: "flex-end", gap: "0.3rem" }}>
//               <img src={audio_icon} style={{ width: "20px", height: "19px" }} alt="" />
//               <p style={{ fontFamily: "Barlow Condensed", fontSize: "18px", fontWeight: "600", color: "#000000DE" }}>
//                 Audio
//               </p>
//             </div>

//             <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", fontWeight: "400" }}>
//               For video inspection
//             </p>

//             {audioPermStatus === "granted" ? (
//               <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "14px", color: "#FC350B", display: "flex", alignItems: "center", gap: "0.3rem", position: "absolute", bottom: "20px", right: "10px" }}>
//                 <img src={tick_icon} style={{ width: "14px" }} alt="" />
//                 <span>Allowed</span>
//               </div>
//             ) : (
//               <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
//                 <button
//                   style={{ border: "1.5px solid #FC350B", padding: "0.1rem 0.5rem", backgroundColor: "white", borderRadius: "4px" }}
//                   onClick={() => handleRetry("audio")}
//                 >
//                   <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FC350B", padding: "0.3rem", margin: 0 }}>
//                     {audioPermStatus === "prompt" ? "Allow" : "Retry"}
//                   </p>
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         <button
//           onClick={handleButtonClick}
//           className="proceed-button"
//           style={{
//             backgroundColor: proceedStatus ? "#FC350B" : "#dcdcdc",
//             color: proceedStatus ? "#ffffff" : "#0000003D",
//             pointerEvents: proceedStatus ? "auto" : "auto"
//           }}
//         >
//           Proceed
//         </button>

//         {/* Low internet dialog */}
//         {speed !== null && speed < 5 && (
//           <Dialog
//             open={openDialogLowInternet}
//             onClose={handleDialogClose}
//             PaperProps={{
//               style: {
//                 width: dialogWidth,
//                 borderRadius: "4px",
//                 margin: "0px",
//                 height: "120px",
//                 zIndex: "999999"
//               }
//             }}
//           >
//             <DialogTitle
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "0.3rem",
//                 fontSize: "1.3rem",
//                 color: "black",
//                 padding: "1rem 0.9rem",
//                 fontWeight: "600",
//                 fontFamily: "Barlow Condensed"
//               }}
//             >
//               <img src={network} style={{ width: "9%" }} alt="" />
//               <span>Low internet connection</span>
//             </DialogTitle>
//             <div style={{ padding: "0 1rem", fontFamily: "'Montserrat', sans-serif" }}>
//               Please switch to a more stable connection to continue seamlessly
//             </div>
//             <IconButton
//               aria-label="close"
//               onClick={handleDialogClose}
//               sx={{ position: "absolute", right: 7, top: 10, color: "black" }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Dialog>
//         )}

//         {/* Optional: show any permission error message */}
//         {errorMessage ? (
//           <div style={{ marginTop: 10, color: "red", fontFamily: "Montserrat", fontSize: 12 }}>
//             {errorMessage}
//           </div>
//         ) : null}

//         {locationError ? (
//           <div style={{ marginTop: 10, color: "red", fontFamily: "Montserrat", fontSize: 12 }}>
//             {locationError} (attempt {retryCount})
//           </div>
//         ) : null}
//       </div>
//     </div>
//   );
// };

// export default Permission2;
import "./Permission.css";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import StepIndicator from "./StepIndicator";
import Support from "../../contact-popup-module/Support";
import InternetSignal from "../internet-strength/InternetSignal";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import tick_icon from "../location-camera-permission/tick_icon.png";
import { set_latitude_longitude, setAuditID } from "../../store/images";

const Permission2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { audit_id } = useParams();

  const [cameraPermission, setCameraPermission] = useState(false);
  const [locationPermission, setLocationPermission] = useState(false);
  const [audioPermission, setAudioPermission] = useState(false);

  const [openPermissionDialog, setOpenPermissionDialog] = useState(false);
  const [openLocPermissionDialog, setOpenLocPermissionDialog] = useState(false);
  const [openCamPermissionDialog, setOpenCamPermissionDialog] = useState(false);
  const [openAudioPermissionDialog, setOpenAudioPermissionDialog] =
    useState(false);

  const [locationError, setLocationError] = useState(null);

  const [dialogWidth, setDialogWidth] = useState("29vw");
  const [dialogText, setDialogText] = useState("0.9rem");

  const [locationPermStatus, setLocationPermStatus] = useState("denied");
  const [cameraPermStatus, setCameraPermStatus] = useState("denied");
  const [audioPermStatus, setAudioPermStatus] = useState("denied");

  const [configDataStatus, setConfigDataStatus] = useState(false);
  const [proceedStatus, setProceedStatus] = useState(false);

  const [retryCount, setRetryCount] = useState(0);

  const [openDialogLowInternet, setOpenDialogLowInternet] = useState(true);
  const [speed, setSpeed] = useState(null);

  const [isWebView, setIsWebView] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ NEW: lock proceed to avoid multi-tap/race on mobile
  const [proceeding, setProceeding] = useState(false);

  const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
  const location_icon = `${process.env.PUBLIC_URL}/custom-icons/location.png`;
  const camera_icon = `${process.env.PUBLIC_URL}/custom-icons/camera.png`;
  const audio_icon = `${process.env.PUBLIC_URL}/custom-icons/audio.png`;
  const network = `${process.env.PUBLIC_URL}/custom-icons/network.png`;

  const uid = useSelector((state) => state.imagesStore.user_userID);
  console.log("permission uid", uid);

  // Detect WebView
  useEffect(() => {
    const checkWebView = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return (
        userAgent.includes("wv") ||
        userAgent.includes("fb") ||
        window.webkit?.messageHandlers
      );
    };
    setIsWebView(checkWebView());
  }, []);

  // Responsive dialog size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 400) setDialogWidth("85vw");
      else if (window.innerWidth <= 475) setDialogWidth("74vw");
      else if (window.innerWidth <= 575) {
        setDialogText("0.6rem");
        setDialogWidth("64vw");
      } else if (window.innerWidth <= 650) setDialogWidth("60vw");
      else if (window.innerWidth <= 775) setDialogWidth("57vw");
      else if (window.innerWidth <= 875) setDialogWidth("55vw");
      else if (window.innerWidth <= 1000) setDialogWidth("48vw");
      else if (window.innerWidth <= 1100) {
        setDialogWidth("45vw");
        setDialogText("0.8rem");
      } else if (window.innerWidth <= 1300) setDialogWidth("40vw");
      else setDialogWidth("35vw");
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch audit details
  const [auditData, setAuditData] = useState(null);
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `/create_audit/get_audit_details2/${audit_id}`
        );
        setConfigDataStatus(true);
        setAuditData(response.data);
        localStorage.setItem(
          "inspectionConfiguration",
          JSON.stringify(response.data)
        );
      } catch (error) {
        console.error("Error fetching audit details:", error);
      }
    };

    if (audit_id) fetchDetails();
  }, [audit_id]);

  // Permission request helpers (single source of truth)
  const requestCameraPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }
      });
      stream.getTracks().forEach((t) => t.stop());
      setCameraPermission(true);
      setCameraPermStatus("granted");
      return true;
    } catch (error) {
      console.error("Camera permission error:", error);
      setCameraPermission(false);
      setCameraPermStatus("denied");

      if (error.name === "NotAllowedError") {
        alert("Please enable camera access in your device settings");
      } else if (error.name === "NotFoundError") {
        alert("No camera found on device");
      } else {
        alert("Camera access failed. Please check device settings.");
      }
      return false;
    }
  };

  const requestAudioPermission = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error("Media devices API not available");
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
      });

      stream.getTracks().forEach((t) => t.stop());

      setAudioPermission(true);
      setAudioPermStatus("granted");
      setErrorMessage("");
      return true;
    } catch (error) {
      console.error("Microphone access error:", error);
      setAudioPermission(false);

      let message = "";
      if (
        error.name === "NotAllowedError" ||
        error.name === "PermissionDeniedError"
      ) {
        message =
          "Microphone permission was denied. Please enable it in your settings.";
        setAudioPermStatus("denied");
      } else if (error.name === "NotFoundError") {
        message = "No microphone device found.";
      } else if (error.name === "NotReadableError") {
        message = "Microphone is already in use or not functioning properly.";
      } else if (error.name === "SecurityError") {
        message = isWebView
          ? "WebView permissions not properly configured. Please check app settings."
          : "Security error accessing microphone.";
      } else {
        message = `Error accessing microphone: ${error.message}`;
      }
      setErrorMessage(message);
      return false;
    }
  };

  const requestLocationPermission = async () => {
    console.log("Requesting location permission...");

    if (!navigator.geolocation) {
      setLocationError("Geolocation not supported");
      setLocationPermStatus("denied");
      setLocationPermission(false);
      return false;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 30000,
      maximumAge: 0
    };

    setRetryCount((c) => c + 1);

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationPermission(true);
          setLocationPermStatus("granted");
          setLocationError(null);
          resolve(true);
        },
        (error) => {
          console.error("Location error:", error);
          setLocationPermission(false);
          setLocationPermStatus("denied");

          let msg = "";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              msg = "Location permission denied";
              break;
            case error.POSITION_UNAVAILABLE:
              msg = "Location information unavailable";
              break;
            case error.TIMEOUT:
              msg = "Location request timed out";
              break;
            default:
              msg = "Unknown location error";
          }
          setLocationError(msg);
          resolve(false);
        },
        options
      );
    });
  };

  // ✅ NEW: Best-effort location getter so Proceed doesn't "hang"
  const getLocationBestEffort = (ms = 2500) =>
    new Promise((resolve) => {
      if (!navigator.geolocation) return resolve(null);

      let done = false;
      const finish = (val) => {
        if (!done) {
          done = true;
          resolve(val);
        }
      };

      const timer = setTimeout(() => finish(null), ms);

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          clearTimeout(timer);
          finish({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude
          });
        },
        () => {
          clearTimeout(timer);
          finish(null);
        },
        { enableHighAccuracy: true, timeout: ms, maximumAge: 0 }
      );
    });

  // proceedStatus (require all 3 + config)
  useEffect(() => {
    const canProceed =
      cameraPermStatus === "granted" &&
      audioPermStatus === "granted" &&
      locationPermStatus === "granted" &&
      configDataStatus;

    setProceedStatus(canProceed);
  }, [cameraPermStatus, audioPermStatus, locationPermStatus, configDataStatus]);

  // Speed test
  const testSpeed = async () => {
    const fileSize = 1 * 1024 * 1024; // 1MB
    const testFile = "https://speed.cloudflare.com/__down?bytes=1000000";
    const startTime = Date.now();

    try {
      const response = await fetch(testFile);
      await response.arrayBuffer();
      const endTime = Date.now();
      const durationInSeconds = (endTime - startTime) / 1000;
      const speedMbps = (
        (fileSize / durationInSeconds / (1024 * 1024)) *
        8
      ).toFixed(2);
      setSpeed(Number(speedMbps));
    } catch (error) {
      console.error("Speed test failed:", error);
      setSpeed(null);
    }
  };

  useEffect(() => {
    testSpeed();
    const intervalId = setInterval(testSpeed, 15000);
    return () => clearInterval(intervalId);
  }, []);

  const handleDialogClose = () => setOpenDialogLowInternet(false);

  const handleRetry = (type) => {
    if (type === "location") {
      setOpenLocPermissionDialog(true);
      requestLocationPermission();
    } else if (type === "camera") {
      setOpenCamPermissionDialog(true);
      requestCameraPermission();
    } else if (type === "audio") {
      setOpenAudioPermissionDialog(true);
      requestAudioPermission();
    }
  };

  // ✅ REPLACED: One-tap Proceed logic (no stale state + no GPS blocking)
  const handleButtonClick = async () => {
    if (proceeding) return;
    setProceeding(true);

    try {
      const locOk =
        locationPermStatus === "granted"
          ? true
          : await requestLocationPermission();

      const camOk =
        cameraPermStatus === "granted" ? true : await requestCameraPermission();

      const audOk =
        audioPermStatus === "granted" ? true : await requestAudioPermission();

      const canProceed = locOk && camOk && audOk && configDataStatus;

      if (!canProceed) return;

      // Navigate immediately
      dispatch(setAuditID(audit_id));
      navigate(`/landscapeMode/${audit_id}`);

      // Best-effort location capture (won't block navigation)
      const loc = await getLocationBestEffort(2500);
      if (loc) dispatch(set_latitude_longitude(loc));
    } finally {
      setProceeding(false);
    }
  };

  // Support popup
  const [openSupport, setOpenSupport] = useState(false);
  const handleClickOpen = () => setOpenSupport(true);
  const handleClose = () => setOpenSupport(false);

  return (
    <div className="loc-cam-permission-parent">
      {speed !== null && <InternetSignal signalStrength={speed} />}

      <img
        src={query_icon}
        alt="Query Icon"
        className="question-div"
        onClick={handleClickOpen}
      />

      <Dialog
        open={openSupport}
        onClose={handleClose}
        className="support-popup-dialog"
      >
        <DialogContent className="support-popup-content">
          <Support />
          <button onClick={handleClose} className="close-btn">
            close
          </button>
        </DialogContent>
      </Dialog>

      <div className="permissions-page">
        <StepIndicator stepNumber={2} />
        <p className="allow-permission-step-indicator">
          All permissions {locationPermStatus}
        </p>
        <p className="allow-permission-div">Allow permission on your device</p>

        <div className="permission-card-parent">
          {/* CAMERA */}
          <div className="permission-card">
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "0.3rem"
              }}
            >
              <img
                src={camera_icon}
                style={{ width: "20px", height: "19px" }}
                alt=""
              />
              <p
                style={{
                  fontFamily: "Barlow Condensed",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#000000DE"
                }}
              >
                Camera
              </p>
            </div>

            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "14px",
                fontWeight: "400"
              }}
            >
              For capturing the livestock
            </p>

            {cameraPermStatus === "granted" ? (
              <div
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "14px",
                  color: "#FC350B",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                  position: "absolute",
                  bottom: "20px",
                  right: "10px"
                }}
              >
                <img src={tick_icon} style={{ width: "14px" }} alt="" />
                <span>Allowed</span>
              </div>
            ) : (
              <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
                <button
                  style={{
                    border: "1.5px solid #FC350B",
                    padding: "0.1rem 0.5rem",
                    backgroundColor: "white",
                    borderRadius: "4px"
                  }}
                  onClick={() => handleRetry("camera")}
                >
                  <p
                    style={{
                      fontSize: "1rem",
                      fontFamily: "'Montserrat', sans-serif",
                      color: "#FC350B",
                      padding: "0.3rem",
                      margin: 0
                    }}
                  >
                    {cameraPermStatus === "prompt" ? "Allow" : "Retry"}
                  </p>
                </button>
              </div>
            )}
          </div>

          {/* LOCATION */}
          <div className="permission-card">
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "0.3rem"
              }}
            >
              <img
                src={location_icon}
                style={{ width: "20px", height: "20px" }}
                alt=""
              />
              <p
                style={{
                  fontFamily: "Barlow Condensed",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#000000DE"
                }}
              >
                Location
              </p>
            </div>

            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "14px",
                fontWeight: "400"
              }}
            >
              For the location of the inspection
            </p>

            {locationPermStatus === "granted" ? (
              <div
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "14px",
                  color: "#FC350B",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                  position: "absolute",
                  bottom: "20px",
                  right: "10px"
                }}
              >
                <img src={tick_icon} style={{ width: "14px" }} alt="" />
                <span>Allowed</span>
              </div>
            ) : (
              <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
                <button
                  style={{
                    border: "1.5px solid #FC350B",
                    padding: "0.1rem 0.5rem",
                    backgroundColor: "white",
                    borderRadius: "4px"
                  }}
                  onClick={() => handleRetry("location")}
                >
                  <p
                    style={{
                      fontSize: "1rem",
                      fontFamily: "'Montserrat', sans-serif",
                      color: "#FC350B",
                      padding: "0.3rem",
                      margin: 0
                    }}
                  >
                    {locationPermStatus === "prompt" ? "Allow" : "Retry"}
                  </p>
                </button>
              </div>
            )}
          </div>

          {/* AUDIO */}
          <div className="permission-card">
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "0.3rem"
              }}
            >
              <img
                src={audio_icon}
                style={{ width: "20px", height: "19px" }}
                alt=""
              />
              <p
                style={{
                  fontFamily: "Barlow Condensed",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#000000DE"
                }}
              >
                Audio
              </p>
            </div>

            <p
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "14px",
                fontWeight: "400"
              }}
            >
              For video inspection
            </p>

            {audioPermStatus === "granted" ? (
              <div
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "14px",
                  color: "#FC350B",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3rem",
                  position: "absolute",
                  bottom: "20px",
                  right: "10px"
                }}
              >
                <img src={tick_icon} style={{ width: "14px" }} alt="" />
                <span>Allowed</span>
              </div>
            ) : (
              <div style={{ position: "absolute", bottom: "20px", right: "10px" }}>
                <button
                  style={{
                    border: "1.5px solid #FC350B",
                    padding: "0.1rem 0.5rem",
                    backgroundColor: "white",
                    borderRadius: "4px"
                  }}
                  onClick={() => handleRetry("audio")}
                >
                  <p
                    style={{
                      fontSize: "1rem",
                      fontFamily: "'Montserrat', sans-serif",
                      color: "#FC350B",
                      padding: "0.3rem",
                      margin: 0
                    }}
                  >
                    {audioPermStatus === "prompt" ? "Allow" : "Retry"}
                  </p>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ✅ Updated proceed button */}
        <button
          onClick={handleButtonClick}
          className="proceed-button"
          disabled={proceeding}
          style={{
            backgroundColor: proceedStatus ? "#FC350B" : "#dcdcdc",
            color: proceedStatus ? "#ffffff" : "#0000003D",
            pointerEvents: "auto",
            opacity: proceeding ? 0.7 : 1
          }}
        >
          {proceeding ? "Please wait..." : "Proceed"}
        </button>

        {/* Low internet dialog */}
        {speed !== null && speed < 5 && (
          <Dialog
            open={openDialogLowInternet}
            onClose={handleDialogClose}
            PaperProps={{
              style: {
                width: dialogWidth,
                borderRadius: "4px",
                margin: "0px",
                height: "120px",
                zIndex: "999999"
              }
            }}
          >
            <DialogTitle
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.3rem",
                fontSize: "1.3rem",
                color: "black",
                padding: "1rem 0.9rem",
                fontWeight: "600",
                fontFamily: "Barlow Condensed"
              }}
            >
              <img src={network} style={{ width: "9%" }} alt="" />
              <span>Low internet connection</span>
            </DialogTitle>
            <div
              style={{
                padding: "0 1rem",
                fontFamily: "'Montserrat', sans-serif"
              }}
            >
              Please switch to a more stable connection to continue seamlessly
            </div>
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{ position: "absolute", right: 7, top: 10, color: "black" }}
            >
              <CloseIcon />
            </IconButton>
          </Dialog>
        )}

        {errorMessage ? (
          <div
            style={{
              marginTop: 10,
              color: "red",
              fontFamily: "Montserrat",
              fontSize: 12
            }}
          >
            {errorMessage}
          </div>
        ) : null}

        {locationError ? (
          <div
            style={{
              marginTop: 10,
              color: "red",
              fontFamily: "Montserrat",
              fontSize: 12
            }}
          >
            {locationError} (attempt {retryCount})
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Permission2;